import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#login_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M13.536 19.591h7.35c.61 0 1.096-.503 1.114-1.114V6.114A1.12 1.12 0 0 0 20.886 5h-7.35a1.12 1.12 0 0 0-1.114 1.114v1.168a.36.36 0 0 0 .719 0V6.114c0-.216.18-.395.395-.395h7.35c.216 0 .395.18.395.395v12.363c0 .216-.18.395-.395.395h-7.35a.4.4 0 0 1-.395-.395v-1.276a.36.36 0 0 0-.36-.36.36.36 0 0 0-.359.36v1.276a1.12 1.12 0 0 0 1.114 1.114M9.26 8.378l3.755 3.738a.36.36 0 0 1 .108.252c0 .09-.036.18-.108.251L9.26 16.375a.36.36 0 0 1-.252.108.36.36 0 0 1-.251-.108.347.347 0 0 1 0-.504l3.126-3.144H2.36a.36.36 0 0 1-.359-.36.36.36 0 0 1 .36-.359h9.523L8.757 8.881a.347.347 0 0 1 0-.503.347.347 0 0 1 .503 0"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="login_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogin;
